export const environment = {
  production: true,
  intermediate_server_url: 'https://white-v2.lightmetrics.co',
  env: 'prod',
};
